/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetIncidentsListRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {GetIncidentsListResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const getIncidentsList = (request:GetIncidentsListRequest, options?: CashRequestOptions) => post<GetIncidentsListRequest, GetIncidentsListResponse>("/2.0/cash/get-incidents-list", request, {...options, rejectOnError: true })